import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ClipboardList, Plus, Trash2, ArrowRight, ShoppingCart } from 'lucide-react';
import { quotesApi, policiesApi } from '../../lib/api';

export default function MyQuotes() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = () => {
    quotesApi.list().then(setItems).catch(() => setItems([])).finally(() => setLoading(false));
  };
  useEffect(refresh, []);

  const accept = async (q, insurer) => {
    const chosen = q.quotes.find((x) => x.insurer === insurer);
    if (!chosen) return;
    const renewal = new Date();
    renewal.setFullYear(renewal.getFullYear() + 1);
    await policiesApi.create({
      quote_id: q.id,
      type: 'home',
      insurer: chosen.insurer,
      premium: chosen.premium,
      renewal_date: renewal.toISOString().slice(0, 10),
      cover_amount: q.data.coverAmount ? Number(q.data.coverAmount) : null,
      property: { address: q.data.address, province: q.data.province },
      status: 'active',
    });
    alert('Policy created. See it under My Policies.');
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this quote?')) return;
    await quotesApi.remove(id);
    refresh();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <span className="eyebrow">Quotes</span>
          <h1 className="mt-2 text-3xl font-bold text-[#0b1f3a]">My Quotes</h1>
        </div>
        <Link to="/home-insurance" className="btn-primary"><Plus size={16} /> New quote</Link>
      </div>

      {loading ? (
        <p className="p-8 text-center text-slate-500 text-sm">Loading...</p>
      ) : items.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center">
          <ClipboardList size={32} className="mx-auto text-slate-300" />
          <p className="mt-3 text-slate-700 font-semibold">No saved quotes</p>
          <p className="text-slate-500 text-sm mt-1">Complete a wizard to save your comparison.</p>
          <Link to="/home-insurance" className="btn-primary mt-5">Start a quote <ArrowRight size={16} /></Link>
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((q) => (
            <div key={q.id} className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
              <div className="p-5 border-b border-slate-100 flex items-center justify-between gap-4">
                <div>
                  <p className="font-semibold text-[#0b1f3a]">{q.data?.address || 'Property'} · {q.data?.province || 'Spain'}</p>
                  <p className="text-xs text-slate-500 mt-0.5">Saved {new Date(q.created_at).toLocaleDateString()} · {q.quotes?.length || 0} insurers</p>
                </div>
                <button onClick={() => remove(q.id)} className="text-slate-400 hover:text-rose-600" title="Delete"><Trash2 size={16} /></button>
              </div>
              <div className="divide-y divide-slate-100">
                {(q.quotes || []).slice(0, 3).map((c, i) => (
                  <div key={c.insurer} className={`p-4 flex items-center gap-4 ${i === 0 ? 'bg-emerald-50/40' : ''}`}>
                    <div className="flex-1">
                      <p className="font-semibold text-[#0b1f3a] text-sm">{c.insurer} {i === 0 && <span className="ml-1 text-[10px] uppercase font-semibold tracking-wider text-emerald-700 bg-emerald-100 px-1.5 py-0.5 rounded-full">Best price</span>}</p>
                      <p className="text-xs text-slate-500 mt-0.5">{(c.highlights || []).slice(0, 2).join(' · ')}</p>
                    </div>
                    <p className="font-bold text-[#0b1f3a]">€{c.premium}<span className="text-xs font-medium text-slate-500">/yr</span></p>
                    <button onClick={() => accept(q, c.insurer)} className="btn-outline !py-2 !px-3 text-xs"><ShoppingCart size={14} /> Accept</button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
